"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * Recursively generates React elements from a given configuration.
 *
 * @param {Object} config - Configuration for the React element.
 * @param {string|Function} config.type - Type of the React element (e.g., 'div', 'span', or a component).
 * @param {Object} config.props - Properties for the React element.
 * @param {Array} config.children - Child elements or text.
 * @returns {React.Element} The generated React element.
 */
function generateReactElement(_ref) {
  var type = _ref.type,
    props = _ref.props,
    children = _ref.children;
  // Handle the case where children is undefined or not an array
  if (children === undefined) {
    return /*#__PURE__*/_react["default"].createElement(type, props);
  } else if (!Array.isArray(children)) {
    throw new Error('Expected "children" to be an array.');
  }
  return /*#__PURE__*/_react["default"].createElement(type, props, children.map(function (child) {
    if (child instanceof Object && child.type) {
      // Ensure child is an object with a type property
      return generateReactElement(child);
    }
    return child;
  }));
}
var _default = exports["default"] = generateReactElement;